import { createContext } from 'preact';

const GlobalStateContext = createContext();

export default GlobalStateContext;
